/**
 * Tenant-scoped print template hook.
 *
 * Loads the saved invoice/print template once per mount from
 * `GET /api/invoice-template` and returns it. The same template
 * (logo, business name, address, phone, tax number, footer, primary
 * color) is shared by invoices, receipts, account statements, expense
 * vouchers, AND management reports — so every printable artifact
 * carries the tenant's own identity.
 *
 * The hook never throws. If the request fails, it returns null and
 * callers should fall back to the iSaloon default brand (handled in
 * `printReport.js`).
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function usePrintTemplate() {
  const [template, setTemplate] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get("/invoice-template");
        if (!cancelled) setTemplate(r.data || null);
      } catch {
        if (!cancelled) setTemplate(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return template;
}
